export function getHumanReadableFileSize(bytes: number) {
  if (!bytes || isNaN(bytes)) {
    bytes = 0;
  }

  if (bytes < 1024) {
    return bytes === 1
      ? '1 Byte'
      : bytes + ' Bytes';
  }

  bytes /= 1024;

  if (bytes < 1024) {
    return bytes.toFixed(2) + ' Kb';
  }

  bytes /= 1024;

  if (bytes < 1024) {
    return bytes.toFixed(2) + ' Mb';
  }

  bytes /= 1024;

  if (bytes < 1024) {
    return bytes.toFixed(2) + ' Gb';
  }

  bytes /= 1024;

  return bytes.toFixed(2) + ' Tb';
}
